export const HOUSE_TABS = ['Summary'];
